// extracted by mini-css-extract-plugin
export default {"container":"tUb0XjU6As8x0uuGO0vs"};